<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">Travel Request</h1>
      <router-link
        :to="`/request/travel/edit/${$route.params.id}`"
        class="button is-small is-primary is-uppercase"
      >Edit</router-link>
    </div>
    <div class="box">
      <table class="table is-fullwidth">
        <tr>
          <th>Employee ID</th>
          <td>{{ travel.employeeId }}</td>
        </tr>
        <tr>
          <th>Name</th>
          <td>{{ travel.name }}</td>
        </tr>
        <tr>
          <th>Mobile</th>
          <td>{{ travel.mobile }}</td>
        </tr>
        <tr>
          <th>Email</th>
          <td>{{ travel.email }}</td>
        </tr>
        <tr>
          <th>From</th>
          <td>{{ travel.startDate | date }}</td>
        </tr>
        <tr>
          <th>To</th>
          <td>{{ travel.endDate | date }}</td>
        </tr>
        <tr>
          <th>Reason</th>
          <td>{{ travel.reason }}</td>
        </tr>
      </table>

      <div class="is-flex">
        <div class="is-expanded">
          <router-link to="/request/travel" class="button is-borderless">Back</router-link>
        </div>
        <div class="is-expanded has-text-right"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      travel: {}
    };
  },
  mounted() {
    let component = this;
    component.$store
      .dispatch("travel/show", component.$route.params.id)
      .then(response => {
        component.travel = response.data;
      });
  }
};
</script>
